import React, { useContext} from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from './views/Login';
import ForgotPassword from './views/forgotPassword';
import Home from './views/admin/Home';
import HomeRegister from './views/worker/Home';
import { UserContext } from './UserContext';
import Protected from './Protected'
import { AdminProvider } from './views/admin/AdminContext';
import { PartnerProvider } from './PartnersContext';
import { MaintenanceProvider } from './MaintenanceContext';
import Register from './views/partners/Register';
const AppRoutes = () => {
    const {user} = useContext(UserContext);

    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="login/:benefitId?" element={<Login />} />
            <Route path="/register"
                 element={
                    <Protected isLoggedIn={user}>
                        <MaintenanceProvider>
                            <HomeRegister  id="homeRegister" />
                        </MaintenanceProvider>
                    </Protected>
                  }
             />
            <Route path="/admin"
                 element={
                    <Protected isLoggedIn={user}>
                        <AdminProvider>
                            <Home id="home"/>
                        </AdminProvider>
                    </Protected>
                  }
             />

            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/partner-register"
                element={
                    <PartnerProvider>
                        <Register/>
                    </PartnerProvider>

                }/>
        </Routes>
    )
}
export default AppRoutes;